export default "__VITE_ASSET__Dglf6JCP__"